import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from '@mui/material'
import { useContext } from 'react'

import { SingleInspectionContext } from '../../../providers/SingleInspectionProvider/SingleInspectionProvider'
import { EditSingleInspectionEntry } from '../../Inspections/EditSingleInspectionEntry'

export const EditSingleInspectionEntryDialog = ({
  id,
  setEditDialog
}: {
  id: string
  setEditDialog: (s: string) => void
}) => {
  const { inspectionWithRelated } = useContext(SingleInspectionContext)
  const entry = inspectionWithRelated?.sections
    .flatMap((s) => s.entries)
    .find((e) => e.id === id)
  return (
    <Dialog
      open={true}
      maxWidth={'sm'}
      fullWidth
      onClose={() => setEditDialog('')}>
      <DialogTitle>Edit Inspection</DialogTitle>
      <DialogContent>
        {entry && <EditSingleInspectionEntry entry={entry} />}
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setEditDialog('')}>Close</Button>
      </DialogActions>
    </Dialog>
  )
}
